import React from 'react'
import { oneOfType, string, number, bool } from 'prop-types'
import { StackView, Box, Typography, Paragraph } from '@telus-uds/components-web'
import DealsIcon from '@telus-uds/palette-allium/build/web/icons/Deals'
import PiggyBankIcon from '@telus-uds/palette-allium/build/web/icons/PiggyBank'

import { ColumnSpacer, NoWrapper } from './styles'
import WithIcon from '../../WithIcon'
import FormattedTrademarkTextWrapper from '../../FormattedTrademarkTextWrapper'

const ICON_MAP = {
  DEALS: DealsIcon, // Discount
  PIGGYBANK: PiggyBankIcon // Promocode
}

const nameFieldTextBuilder = (name, icon, suffixName) => {
  const suffixNameStrong = suffixName ? (
    <span data-testid="suffix-name-strong">
      <Typography variant={{ size: 'medium' }} fontWeight="bold">{` ${suffixName}`}</Typography>
    </span>
  ) : null

  // Get the icon component from the map, ensuring it's a valid component
  const prefixIconComponent = icon ? ICON_MAP[icon] : null

  // Only use WithIcon if we have a valid icon component
  if (prefixIconComponent) {
    return (
      <WithIcon icon={prefixIconComponent}>
        <FormattedTrademarkTextWrapper text={name} />
        {suffixNameStrong}
      </WithIcon>
    )
  }

  return (
    <Paragraph>
      <FormattedTrademarkTextWrapper text={name} />
      {suffixNameStrong}
    </Paragraph>
  )
}

const NameAndPrice = ({ id, name, price, after, prefixIcon, suffixName, shouldMaskPrice }) => {
  const nameFieldText = nameFieldTextBuilder(name, prefixIcon, suffixName)

  return (
    <Box vertical={1}>
      <StackView
        direction="row"
        tokens={{ justifyContent: 'space-between' }}
        key={name}
        testID={`breakdown-${name.trim()}-${id}`}
      >
        <ColumnSpacer>{nameFieldText}</ColumnSpacer>
        <NoWrapper>
          <span data-di-mask={shouldMaskPrice ? 'true' : null}>
            <Typography variant={{ size: 'medium' }}>
              {price}
              {after}
            </Typography>
          </span>
        </NoWrapper>
      </StackView>
    </Box>
  )
}

NameAndPrice.propTypes = {
  name: string.isRequired,
  price: string.isRequired,
  after: string,
  id: oneOfType([string, number]),
  prefixIcon: string,
  suffixName: string,
  shouldMaskPrice: bool
}

NameAndPrice.defaultProps = {
  after: '',
  id: '',
  prefixIcon: undefined,
  suffixName: undefined,
  shouldMaskPrice: null
}

export default NameAndPrice
